import type { CommunicationTagKey } from '#types';

export type CommunicationTag = {
  label: string;
  color: string;
};

export const communicationTags: Record<CommunicationTagKey, CommunicationTag> = {
  'sent': {
    label: 'Auto',
    color: 'blue',
  },
  'agent': {
    label: 'AI Agent',
    color: 'green',
  },
  'drag': {
    label: 'Drag & Drop',
    color: 'default',
  },
  'manual': {
    label: 'Manual Entry',
    color: 'default',
  }
};
